import * as Cookies from 'js-cookie'

export enum CookieKey {
  AccessToken = 'accessToken',
  AccountState = 'accountState',
}

export function getItem(key: CookieKey): string | undefined
export function getItem(key: string): string | undefined {
  return Cookies.get(key)
}

export function setItem(
  key: CookieKey,
  value: string | object,
  options?: Cookies.CookieAttributes,
): void
export function setItem(
  key: string,
  value: string | object,
  options?: Cookies.CookieAttributes,
): void {
  Cookies.set(key, value)
}

export function deleteItem(
  key: CookieKey,
  options?: Cookies.CookieAttributes,
): void
export function deleteItem(
  key: string,
  options?: Cookies.CookieAttributes,
): void {
  return Cookies.remove(key, options)
}
